import "@/App.css";
import { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { SmoothScroll } from "@/components/holideviser/SmoothScroll";
import { HomePage } from "@/components/holideviser/HomePage";
import { PlanMyTrip } from "@/components/holideviser/PlanMyTrip";
import { DiscoverographyPage } from "@/components/holideviser/DiscoverographyPage";
import { DestinationsPage } from "@/components/holideviser/DestinationsPage";
import { DestinationDetailPage } from "@/components/holideviser/DestinationDetailPage";
import { DestinationEditPage } from "@/components/holideviser/DestinationEditPage";
import { DaNangAfterDark } from "@/components/holideviser/DaNangAfterDark";
import { ContactPage } from "@/components/holideviser/ContactPage";
import { PolicyPage } from "@/components/holideviser/PolicyPage";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminDashboard } from "@/components/admin/AdminDashboard";
import { AdminTripDetail } from "@/components/admin/AdminTripDetail";
import { AdminTripBuilder } from "@/components/admin/AdminTripBuilder";
import { TripView } from "@/components/holideviser/TripView";
import { getToken } from "@/components/admin/adminApi";

function AdminGuard({ children }) {
  return getToken() ? children : <Navigate to="/admin" replace />;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <SmoothScroll>
      <div className="grain-overlay" aria-hidden="true" />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/discoverography" element={<DiscoverographyPage />} />
        <Route path="/discoverography/da-nang-after-dark" element={<DaNangAfterDark />} />
        <Route path="/destinations" element={<DestinationsPage />} />
        <Route path="/destinations/da-nang" element={<DestinationEditPage slug="da-nang" />} />
        <Route path="/destinations/ho-chi-minh-city" element={<DestinationEditPage slug="ho-chi-minh-city" />} />
        <Route path="/destinations/goa" element={<DestinationEditPage slug="goa" />} />
        <Route path="/destinations/:slug" element={<DestinationDetailPage />} />
        <Route path="/plan-my-trip" element={<PlanMyTrip />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PolicyPage kind="privacy" />} />
        <Route path="/terms" element={<PolicyPage kind="terms" />} />
        <Route path="/trip/:secureToken" element={<TripView />} />
        <Route path="/admin" element={getToken() ? <Navigate to="/admin/trips" replace /> : <AdminLogin />} />
        <Route path="/admin/trips" element={<AdminGuard><AdminDashboard /></AdminGuard>} />
        <Route path="/admin/trips/:id" element={<AdminGuard><AdminTripDetail /></AdminGuard>} />
        <Route path="/admin/trips/:id/edit" element={<AdminGuard><AdminTripBuilder /></AdminGuard>} />
      </Routes>
    </SmoothScroll>
  );
}

export default App;
